"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightButton = exports.LeftButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const LeftButton = exports.LeftButton = (0, _mui.styled)(_components.IconButton, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isFirst', 'origin'])
})(({
  isFirst,
  origin,
  theme
}) => ({
  ...(origin === 'widget' && {
    bottom: theme.spacing(0),
    display: 'none',
    position: 'absolute',
    zIndex: 3,
    left: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      display: 'grid'
    },
    [theme.breakpoints.up('lg')]: {
      left: theme.spacing(8)
    }
  }),
  ...(origin === 'details' && {
    gridColumn: '1 / 2',
    gridRow: '1 / 2',
    justifySelf: 'start',
    alignSelf: 'center',
    zIndex: 10,
    [theme.breakpoints.up('lg')]: {
      justifySelf: 'center',
      alignSelf: 'center',
      gridColumn: '1 / 2'
    }
  }),
  ...(isFirst && {
    visibility: 'hidden'
  })
}));
const RightButton = exports.RightButton = (0, _mui.styled)(_components.IconButton, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isLast', 'origin'])
})(({
  isLast,
  origin,
  theme
}) => ({
  ...(origin === 'widget' && {
    bottom: theme.spacing(0),
    display: 'none',
    position: 'absolute',
    zIndex: 3,
    right: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      display: 'grid'
    },
    [theme.breakpoints.up('lg')]: {
      right: theme.spacing(8)
    }
  }),
  ...(origin === 'details' && {
    gridColumn: '3 / 4',
    gridRow: '1 / 2',
    justifySelf: 'end',
    alignSelf: 'center',
    zIndex: 10,
    [theme.breakpoints.up('lg')]: {
      justifySelf: 'center',
      alignSelf: 'center'
    }
  }),
  ...(isLast && {
    visibility: 'hidden'
  })
}));
